import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Typography, Form, Button } from 'antd'
import { LeftOutlined } from '@ant-design/icons'

import { actions } from '../create-company-page/actions'
import IntlMessages from '../../../util/IntlMessages'

import { UserSignUpForm } from '../../../components/user-signup-form'

import { ICreateCompanyState, ICreateUser } from '../create-company-page/types'
import { FrontendUrls } from '../../../types/urls'
import { resolveNameParts, joinFullName } from '@vacationtracker/shared/functions/split-full-name'

const { Title, Paragraph } = Typography

interface IPersonalInfoProps {
  dispatch: Function
  state: ICreateCompanyState
}

const PersonalInfo = ({ dispatch, state }: IPersonalInfoProps): React.ReactElement => {
  const [form] = Form.useForm()
  const history = useHistory()

  const { createUser } = state

  useEffect(() => {
    if (createUser.platform === 'email') {
      form.setFieldsValue({
        ...resolveNameParts(createUser.firstName, createUser.lastName, createUser.name),
        password: createUser.userPassword,
        repeatPassword: createUser.userRepeatPassword,
      })
    } else {
      dispatch(actions.setCurrentStep('connectPlatform'))
    }
  }, [createUser])

  // The first thing this screen asks for. Done from here rather than in the shared form,
  // which other screens open with a different field in front.
  useEffect(() => {
    form.getFieldInstance('firstName')?.focus()
  }, [])

  const initialValues = {
    ...resolveNameParts(createUser.firstName, createUser.lastName, createUser.name),
    password: createUser.userPassword,
    repeatPassword: createUser.userRepeatPassword,
  }

  const handlePersonalInfo = async () => {
    try {
      const formValues = await form.validateFields()
      const userFromStorage: ICreateUser = JSON.parse(localStorage.getItem('vtCreateUser') || '{}')
      const firstName = (formValues.firstName ?? '').trim()
      const lastName = (formValues.lastName ?? '').trim()
      userFromStorage.name = joinFullName(firstName, lastName)
      userFromStorage.firstName = firstName
      userFromStorage.lastName = lastName
      userFromStorage.userPassword = formValues.password
      userFromStorage.userRepeatPassword = formValues.repeatPassword
      localStorage.setItem('vtCreateUser', JSON.stringify(userFromStorage))
      history.push(`${FrontendUrls.signup}${FrontendUrls.companyDetails}`)
      dispatch(actions.setCreateUser(userFromStorage))
      dispatch(actions.setCurrentStep('createCompany'))
    } catch (error) {
      console.log('🚀 ~ error:', error)
    }
  }

  return (
    <>
      <div className="auth-sidebar-form-back-buttonn">
        <Button
          onClick={() => {
            history.goBack()
          }}
        >
          <LeftOutlined />
        </Button>
      </div>
      <div className="personal-info-container">
        <Title level={3}>
          <IntlMessages id="createCompany.tellUsAboutYourself" />
        </Title>
        <Paragraph className="subtitle">
          <IntlMessages id="createCompany.tellUsAboutYourself.description" values={{ br: () => <br /> }} />
        </Paragraph>
        <Form
          disabled={state.isCreateCompanyLoader}
          form={form}
          layout="vertical"
          onFinish={() => {
            handlePersonalInfo()
          }}
          className="personal-info-form"
          initialValues={initialValues}
          requiredMark="optional"
        >
          <UserSignUpForm addAvatar={false} form={form} splitName />
          <Form.Item>
            <Button block loading={state.isCreateCompanyLoader} htmlType="submit" type="primary">
              <IntlMessages id="createCompany.youAreAlmostThere" />
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  )
}

export default PersonalInfo
